// SocialGlyph — inline-SVG brand marks for the social sign-in buttons.
//
// INLINE SVG ONLY: no external <script>, no CDN, no remote <img>. TournyFlex
// ships zero third-party scripts, so the provider logos are hand-inlined here
// as <svg> paths (same pattern as BottomNav's icons). Each glyph inherits the
// button's text color via fill="currentColor", so a white label yields a white
// glyph on the brand-colored field.
//
// Keyed by the Supabase provider id used in src/lib/socialProviders.js
// ('facebook', 'twitter'). Google is wired-but-hidden (D-283); it renders no
// glyph today and would need one added here if ENABLED_SOCIAL brings it back.

// Facebook "f" letterform (white glyph on the #1877F2 field). viewBox matches
// the standard Facebook brand "f" mark.
const FacebookGlyph = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 512"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M80 299.3V512h116V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8h66z" />
  </svg>
)

// X (formerly Twitter) mark (white glyph on the #000000 field).
const XGlyph = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
  </svg>
)

// Inline brand glyph for a social provider id, or null for a provider with no
// glyph (e.g. hidden Google). `size` is the square px edge; default 18 keeps it
// in scale with the button's 0.9rem label.
export default function SocialGlyph({ provider, size = 18 }) {
  if (provider === 'facebook') return <FacebookGlyph size={size} />
  if (provider === 'twitter') return <XGlyph size={size} />
  return null
}
